
import _ from 'lodash';

/* @ngInject */
export default function hpValidDate(moment) {
    return {
        require: 'ngModel',
        restrict: 'A',

        link(scope, element, attrs, ngModelCtrl) {
            function validateEntry(text) {
                if (!text || text.length < 8) {
                    ngModelCtrl.$setValidity('valid', true);
                    element.removeClass('invalid');
                } else {
                    let parsedDate;
                    const today = moment();
                    if (text.length > 10) {
                        parsedDate = text;
                    } else if (text.length === 10) {
                        const date1 = text.split('/');
                        const date2 = text.split('-');
                        const dateArray = [];

                        const splitDate = date1.length > 1 ? date1 : date2;

                        _.each(splitDate, (d, index) => {
                            if (index === 1) {
                                dateArray.push(parseInt(d) - 1);
                            } else {
                                dateArray.push(parseInt(d));
                            }
                        });

                        parsedDate = dateArray;
                    } else {
                        parsedDate = [];
                        parsedDate.push(parseInt(text.substring(4)));
                        parsedDate.push(parseInt(text.substring(0, 2)) - 1);
                        parsedDate.push(parseInt(text.substring(2, 4)));
                    }

                    if (moment(parsedDate).isAfter(today, 'date')) {
                        ngModelCtrl.$setValidity('valid', true);
                        element.removeClass('invalid');
                    } else {
                        ngModelCtrl.$setValidity('valid', false);
                        element.addClass('invalid');
                    }
                }

                return text;
            }

            scope.$on('reset', () => {
                validateEntry(null);
            });

            ngModelCtrl.$parsers.push(validateEntry);
        },
    };
}




// WEBPACK FOOTER //
// ./src/app/common/angular/directives/hpValidDate.directive.js